module.exports = __webpack_public_path__ + "img/port5.08f16106.png";